
import React from "react";
import { NursingHomeResults } from "@/components/nursing-homes/county/NursingHomeResults";

interface ResultsContainerProps {
  isLoading: boolean;
  error: Error | null;
  nursingHomes: any[];
  countyName: string;
  countySlug: string | undefined;
  searchQuery: string;
}

export function ResultsContainer({
  isLoading,
  error,
  nursingHomes,
  countyName,
  countySlug,
  searchQuery
}: ResultsContainerProps) {
  return (
    <div className="mb-12">
      <NursingHomeResults 
        isLoading={isLoading}
        error={error}
        nursingHomes={nursingHomes}
        countyName={countyName}
        countySlug={countySlug || ''}
        searchQuery={searchQuery}
      />
    </div>
  );
}
